import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { CertificacionPrecio } from "../models/PlanesUsuario/CertificacionPrecio";
import { InitialData } from "../models/PlanesUsuario/InitialData";
import { Plan } from "../models/PlanesUsuario/Plan";
import { PlanFacturacion } from "../models/PlanesUsuario/PlanFacturacion";
import { PlanUsuario } from "../models/PlanesUsuario/PlanUsuario";
import { Resumen } from "../models/PlanesUsuario/Resumen";
import { Reseller } from "../models/Reseller/Reseller";
import { ResellerFilter } from "../models/Reseller/ResellerFilter";
import { Page } from "../shared/models/Page";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Response } from "../shared/models/Response";
import { SoporteButton } from "../shared/models/SoporteButton.enum";
import { Cupon } from "../models/PlanesUsuario/Cupon";
import { CambioPlanPartner } from "../models/PlanesUsuario/CambioPlanPartner";
import { Adicional } from "../models/Emisor/Adicional";
import { SessionUser } from "../shared/models/sessionUser";
import { TokenStorageService } from "./token-storage.service";
import { DteMonthData } from "../models/Emisor/DteMonthData";

@Injectable({
	providedIn: "root",
})
export class PlanUsuarioService {
	private REST_API_SERVER = environment.backend_server + "/planusuario";
	// private buttonActionsSubject: Subject<SoporteButton>;
	// public buttonActionsObservable: Observable<SoporteButton>;

	constructor(private http: HttpClient, private tokenService: TokenStorageService) {
		// this.buttonActionsSubject = new Subject<SoporteButton>();
		// this.buttonActionsObservable = this.buttonActionsSubject.asObservable();
	}

	getDataByUser(idUsuario: string) {
		return this.http.get<Array<PlanUsuario>>(this.REST_API_SERVER + "/" + idUsuario);
	}

	getContratacionDataByCompany(idEmisor: string) {
		return this.http.get<Array<PlanUsuario>>(this.REST_API_SERVER + "/company/" + idEmisor);
	}

	getPlanesByCompany(idEmisor: string) {
		return this.http.get<Array<PlanUsuario>>(this.REST_API_SERVER + "/company/plan/" + idEmisor);
	}
	
	getFacturasByPlan(idPlan: string) {
		return this.http.get<Array<PlanFacturacion>>(this.REST_API_SERVER + "/facturas/" + idPlan);
	}

	getFacturaPDF(idFactura: string): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER + "/facturas/pdf/" + idFactura);
	}

	cancelarPlan(idPlan: string): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER + "/cancelar/" + idPlan);
	}

	cambiarPlanPartner(model: CambioPlanPartner): Observable<Response<any>> {
		return this.http.post<Response<any>>(this.REST_API_SERVER + "/partner/change-plan", model);
	}

	checkUsers(idUsuario: string, idEmisor: string): Observable<boolean> {
		return this.http.get<boolean>(this.REST_API_SERVER + "/usuarios/" + idUsuario + "/" + idEmisor);
	}

	getCurrentDocuments(idPlanUsuario: string): Observable<any> {
		return this.http.get<any>(this.REST_API_SERVER + "/currentdte/" + idPlanUsuario);
	}

	getInitialData() {
		return this.http.get<InitialData>(this.REST_API_SERVER + "/initialdata");
	}

	getCalculos(idPlan, meses, tipoCertificacion, codigoCupon, certificaciones: CertificacionPrecio[], 
		adicionalRecibidos: Adicional, adicionalPDF: Adicional, fechaDesde: string, conProporcional: boolean,
		idPlanNuevo:string = null, mesesNuevo:number = null,totalCertificadoDigital: number= null, abono: number = null): Observable<Resumen> {
		let url = this.REST_API_SERVER + "/" + idPlan + "/" + meses + "/" + tipoCertificacion + "/" + fechaDesde + "/" + conProporcional;
		if (codigoCupon === undefined || codigoCupon === "") {
			url += "/null";
		} else {
			url += "/" + codigoCupon;
		}
		if (totalCertificadoDigital != null) {
			url += `/${totalCertificadoDigital}`;
		}
		if (idPlanNuevo && mesesNuevo) {
			url += `/${idPlanNuevo}/${mesesNuevo}`;
		}
		return this.http.post<Resumen>(url, {
				certificaciones,
				adicionales: [adicionalRecibidos, adicionalPDF],
				abono
		});
	}

	getCupon(cupon: string) {
		return this.http.get<Cupon>(this.REST_API_SERVER + "/cupones/" + cupon);
	}

	doPayment(resumen: Resumen): Observable<Response<any>> {
		return this.http.post<Response<any>>(this.REST_API_SERVER + "/payment", resumen);
	}

	getActualPlan() {
		let planActivo: PlanUsuario;
		let _userSession = this.tokenService.getUser() as SessionUser;
		if (_userSession.planes && _userSession.planes.length > 0) {
			for (let i = _userSession.planes.length - 1; i >= 0; i--) {
				if (_userSession.planes[i].emisorId === this.tokenService.getCompany()) {
					planActivo = _userSession.planes[i];
					break;
				}
			}
			if (!planActivo) {
				planActivo = _userSession.planes[0];
			}
		}
		return planActivo;
	}
	getDteChartData(emisorId: string): Observable<Response<DteMonthData[]>> {
		return this.http.get<Response<DteMonthData[]>>(
			`${this.REST_API_SERVER}/dtechart/${emisorId}?monthsCount=6`
		);
	  }
	  
}
